import React, { useEffect, useState } from "react";
import "./WatterBuildingForm.scss";
import { useTranslation } from "react-i18next";
import { Field, Form, Formik } from "formik";
import { hideLoading, showLoading } from "../../../reducers/app";
import { client } from "../../../App";
import { INVOICE_PARTITION_CALCULATION } from "../../../helpers/queries";
import { useDispatch } from "react-redux";
import {
  initialValuesWatterBuilding,
  schemaWatterBuilding,
} from "./schemaValidation";

const WatterBuildingForm = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [activeColumn, setActiveColumn] = useState("");
  let formik;
  const [initialValues] = useState(initialValuesWatterBuilding);
  const [unit_0, setUnit_0] = useState();
  const [unit_1, setUnit_1] = useState();
  const [unit_2, setUnit_2] = useState();
  const [unit_3, setUnit_3] = useState();
  const [unit_4, setUnit_4] = useState();
  const [unit_5, setUnit_5] = useState();
  const [unit_6, setUnit_6] = useState();
  const [unit_7, setUnit_7] = useState();
  const [unit_8, setUnit_8] = useState();
  const [unit_9, setUnit_9] = useState();
  const [unit_10, setUnit_10] = useState();
  const [non_residential, setNon_residential] = useState();

  useEffect(() => {
    formik.resetForm();
    setUnit_0("");
    setUnit_1("");
    setUnit_2("");
    setUnit_3("");
    setUnit_4("");
    setUnit_5("");
    setUnit_6("");
    setUnit_7("");
    setUnit_8("");
    setUnit_9("");
    setUnit_10("");
    setNon_residential("");
  }, [props.amount, formik]);

  const handleWatterBuildingForm = (values, { setErrors }, t) => {
    const valuesArray = Object.entries(values);
    const newValues = valuesArray.reduce((a, c) => {
      let [id, item] = c;
      return { ...a, [id]: +item };
    }, {});

    handleWatterBuilding(newValues)
      .then((data) => {
        const { condominiumPartition } = data.data.invoicePartitionCalculation;
        setUnit_0(condominiumPartition.unit_0.unitAmount);
        setUnit_1(condominiumPartition.unit_1.unitAmount);
        setUnit_2(condominiumPartition.unit_2.unitAmount);
        setUnit_3(condominiumPartition.unit_3.unitAmount);
        setUnit_4(condominiumPartition.unit_4.unitAmount);
        setUnit_5(condominiumPartition.unit_5.unitAmount);
        setUnit_6(condominiumPartition.unit_6.unitAmount);
        setUnit_7(condominiumPartition.unit_7.unitAmount);
        setUnit_8(condominiumPartition.unit_8.unitAmount);
        setUnit_9(condominiumPartition.unit_9.unitAmount);
        setUnit_10(condominiumPartition.unit_10.unitAmount);
        setNon_residential(condominiumPartition.non_residential.unitAmount);
        // setTotal(+unit_0 + +unit_1 + +unit_2 + +unit_3 + +unit_4 + +unit_5 + +unit_6 + +unit_7 + +unit_8 + +unit_9 + +unit_10
        //   + +non_residential)

        setActiveColumn("active-column");

        dispatch(hideLoading());
      })
      .catch((err) => {
        console.log("[ERROR CATCH]", err);
        setErrors(err.errors[0].extensions);
        dispatch(hideLoading());
      });
  };

  const handleWatterBuilding = async (values) => {
    try {
      await dispatch(showLoading());
      return await getBillDataQuery(values);
    } catch (error) {
      throw error;
    }
  };
  const getBillDataQuery = (values) =>
    client(true).query({
      query: INVOICE_PARTITION_CALCULATION,
      variables: { ...values, amountInvoice: props.amount },
    });

  return (
    <div
      className="WatterBuildingForm"
      data-testid="WatterBuildingForm"
    >
      <div className="text-container">
        <h2 className={"title headline-bold-fs4"}>
          {t("casses.amministratori_di_condominio.consumo-aqua.title")}
        </h2>
        <div className={"description paragraph-main-fs8"}>
          <div className="font-variation">
            {t("casses.amministratori_di_condominio.consumo-aqua.description")}
          </div>
        </div>
      </div>
      <div className={"table-form"}>
        <div className={"column-left"}>
          <div className={"table-header p-5 paragraph-main-fs8"}>
            {t("casses.amministratori_di_condominio.consumo-aqua.residenti")}
          </div>
          <div className={"table-row paragraph-main-fs8"}>0</div>
          <div className={"table-row paragraph-main-fs8"}>1</div>
          <div className={"table-row paragraph-main-fs8"}>2</div>
          <div className={"table-row paragraph-main-fs8"}>3</div>
          <div className={"table-row paragraph-main-fs8"}>4</div>
          <div className={"table-row paragraph-main-fs8"}>5</div>
          <div className={"table-row paragraph-main-fs8"}>6</div>
          <div className={"table-row paragraph-main-fs8"}>7</div>
          <div className={"table-row paragraph-main-fs8"}>8</div>
          <div className={"table-row paragraph-main-fs8"}>9</div>
          <div className={"table-row paragraph-main-fs8"}>10</div>
          <div className={"table-row non-abitative paragraph-main-fs8"}>
            {t(
              "casses.amministratori_di_condominio.consumo-aqua.non-abitative"
            )}
          </div>
          {/*<div className={'table-row p-5 totale'}>*/}
          {/*{t('common.total')}*/}
          {/*</div>*/}
        </div>
        <div className={"column-middle"}>
          <Formik
            innerRef={(p) => (formik = p)}
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={schemaWatterBuilding}
            onSubmit={(value, props) => {
              handleWatterBuildingForm(value, props, t);
            }}
          >
            {({ errors, touched, submitCount, setFieldValue }) => (
              <Form id={"amministratori-condominio-watter-form"} noValidate>
                <div className={"table-header p-5 paragraph-main-fs8"}>
                  {t(
                    "casses.amministratori_di_condominio.consumo-aqua.numerosita"
                  )}
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_0"
                          name="unit_0"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_0 && touched.unit_0 && submitCount > 0
                              ? "unit_0-error"
                              : null
                          }
                        />

                        {errors.unit_0 && touched.unit_0 && submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_0-error"}
                          >
                            {" "}
                            {errors.unit_0}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_1"
                          name="unit_1"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_1 && touched.unit_1 && submitCount > 0
                              ? "unit_1-error"
                              : null
                          }
                        />

                        {errors.unit_1 && touched.unit_1 && submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_1-error"}
                          >
                            {errors.unit_1}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_2"
                          name="unit_2"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_2 && touched.unit_2 && submitCount > 0
                              ? "unit_2-error"
                              : null
                          }
                        />

                        {errors.unit_2 && touched.unit_2 && submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_2-error"}
                          >
                            {errors.unit_2}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_3"
                          name="unit_3"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_3 && touched.unit_3 && submitCount > 0
                              ? "unit_3-error"
                              : null
                          }
                        />

                        {errors.unit_3 && touched.unit_3 && submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_3-error"}
                          >
                            {errors.unit_3}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_4"
                          name="unit_4"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_4 && touched.unit_4 && submitCount > 0
                              ? "unit_4-error"
                              : null
                          }
                        />

                        {errors.unit_4 && touched.unit_4 && submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_4-error"}
                          >
                            {errors.unit_4}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_5"
                          name="unit_5"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_5 && touched.unit_5 && submitCount > 0
                              ? "unit_5-error"
                              : null
                          }
                        />

                        {errors.unit_5 && touched.unit_5 && submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_5-error"}
                          >
                            {errors.unit_5}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_6"
                          name="unit_6"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_6 && touched.unit_6 && submitCount > 0
                              ? "unit_6-error"
                              : null
                          }
                        />

                        {errors.unit_6 && touched.unit_6 && submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_6-error"}
                          >
                            {errors.unit_6}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_7"
                          name="unit_7"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_7 && touched.unit_7 && submitCount > 0
                              ? "unit_7-error"
                              : null
                          }
                        />

                        {errors.unit_7 && touched.unit_7 && submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_7-error"}
                          >
                            {errors.unit_7}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_8"
                          name="unit_8"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_8 && touched.unit_8 && submitCount > 0
                              ? "unit_8-error"
                              : null
                          }
                        />

                        {errors.unit_8 && touched.unit_8 && submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_8-error"}
                          >
                            {errors.unit_8}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_9"
                          name="unit_9"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_9 && touched.unit_9 && submitCount > 0
                              ? "unit_9-error"
                              : null
                          }
                        />

                        {errors.unit_9 && touched.unit_9 && submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_9-error"}
                          >
                            {errors.unit_9}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="unit_10"
                          name="unit_10"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.unit_10 && touched.unit_10 && submitCount > 0
                              ? "unit_10-error"
                              : null
                          }
                        />

                        {errors.unit_10 &&
                        touched.unit_10 &&
                        submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"unit_10-error"}
                          >
                            {errors.unit_10}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"table-row"}>
                  <div className={"row"}>
                    <div className={"col-sm-12 "}>
                      <div className="form-group d-flex flex-column">
                        <Field
                          className={"form-control"}
                          type="text"
                          placeholder={t(
                            "cases.allacciamento.step5_1.numeroCondominialeUnita.placeholder"
                          )}
                          id="non_residential"
                          name="non_residential"
                          disabled={!props.amount}
                          aria-describedby={
                            errors.non_residential &&
                            touched.non_residential &&
                            submitCount > 0
                              ? "non_residential-error"
                              : null
                          }
                        />

                        {errors.non_residential &&
                        touched.non_residential &&
                        submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"non_residential-error"}
                          >
                            {errors.non_residential}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>

                {/*<div className={'table-row p-5'}>*/}

                {/*</div>*/}
                <div className={"table-row p-4"}>
                  <div className={"col-sm-12 p-0"}>
                    <div className="d-flex justify-content-center btn-content">
                      <button
                        className={"btn btn-primary calcola-btn"}
                        type="submit"
                        disabled={!props.amount}
                      >
                        {t(
                          "casses.amministratori_di_condominio.bollette.button.calcola.label"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className={"column-right " + activeColumn}>
          <div className={"table-header p-5 paragraph-main-fs8"}>
            {t(
              "casses.amministratori_di_condominio.consumo-aqua.importo-unitario"
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_0 === "number" ? (
              <>
                {unit_0} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_1 === "number" ? (
              <>
                {unit_1} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_2 === "number" ? (
              <>
                {unit_2} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_3 === "number" ? (
              <>
                {unit_3} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_4 === "number" ? (
              <>
                {unit_4} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_5 === "number" ? (
              <>
                {unit_5} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_6 === "number" ? (
              <>
                {unit_6} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_7 === "number" ? (
              <>
                {unit_7} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_8 === "number" ? (
              <>
                {unit_8} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_9 === "number" ? (
              <>
                {unit_9} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof unit_10 === "number" ? (
              <>
                {unit_10} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className={"table-row paragraph-main-fs8"}>
            {typeof non_residential === "number" ? (
              <>
                {non_residential} <span> €</span>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <div className={"description paragraph-main-fs8"}>
        {t("casses.amministratori_di_condominio.footer.header.part1")}
        <a
          target={"_blank"}
          href={
            "https://www.gruppocap.it/it/servizi-per-i-cittadini/la-nostra-offerta/tariffe"
          }
          rel="noopener noreferrer"
        >
          <span className={"underline-link paragraph-large-fs7"}>
            {t("casses.amministratori_di_condominio.footer.header.part2")}
          </span>
        </a>
        {t("casses.amministratori_di_condominio.footer.header.part3")}
        <br />
        {t("casses.amministratori_di_condominio.footer.description.part1")}
        <a
          target={"_blank"}
          href={"https://www.arera.it/allegati/docs/17/665-17all.pdf"}
          rel="noopener noreferrer"
        >
          <span className={"underline-link"}>
            {t(
              "casses.amministratori_di_condominio.footer.description.part2"
            )}
          </span>
        </a>
      </div>
    </div>
  );
};

WatterBuildingForm.propTypes = {};

export default WatterBuildingForm;
